import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-form",
  "use": "icon-form-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-form\"><path d=\"M202 172v680a30 30 0 0 0 30 30h560a30 30 0 0 0 30-30V172a30 30 0 0 0-30-30H232a30 30 0 0 0-30 30z m530 650H292a30 30 0 0 1-30-30V232a30 30 0 0 1 30-30h440a30 30 0 0 1 30 30v560a30 30 0 0 1-30 30z\" p-id=\"29790\" /><path d=\"M322 313.5m30 0l320 0q30 0 30 30l0 0q0 30-30 30l-320 0q-30 0-30-30l0 0q0-30 30-30Z\" p-id=\"29791\" /><path d=\"M322 485.5m30 0l320 0q30 0 30 30l0 0q0 30-30 30l-320 0q-30 0-30-30l0 0q0-30 30-30Z\" p-id=\"29792\" /><path d=\"M322 650.5m30 0l320 0q30 0 30 30l0 0q0 30-30 30l-320 0q-30 0-30-30l0 0q0-30 30-30Z\" p-id=\"29793\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/form.svg
// module id = sTIr
// module chunks = 25